import { useState } from "react";

const C = {
  surface2:"#202020", border:"#2a2a2a", muted:"#666",
  orange:"#FF5F1F", magenta:"#E8197D", white:"#fff",
};

const inp = (x={}) => ({ background:C.surface2, border:`0.5px solid ${C.border}`, borderRadius:8, padding:"9px 12px", color:C.white, fontSize:13, outline:"none", width:"100%", boxSizing:"border-box", ...x });
const btn = (v="primary",x={}) => ({ padding:"8px 16px", borderRadius:8, fontSize:13, fontWeight:500, cursor:"pointer", border:"none", boxSizing:"border-box", ...(v==="primary"?{background:`linear-gradient(135deg,${C.orange},${C.magenta})`,color:C.white}:{}), ...(v==="ghost"?{background:"none",border:`0.5px solid ${C.border}`,color:C.muted}:{}), ...x });

const fileIcons = {
  drive:{ label:"Drive", color:"#4ade80" },
  docs: { label:"Docs",  color:"#60a5fa" },
  sheet:{ label:"Sheet", color:"#F5A623" },
  link: { label:"Lenke", color:C.muted   },
};

export function FilesEditor({ files, onChange }) {
  const [n,setN]=useState("");
  const [u,setU]=useState("");

  const add=()=>{
    if(!u) return;
    const type = u.includes("docs.google")?"docs":u.includes("sheets")?"sheet":u.includes("drive.google")?"drive":"link";
    onChange([...files,{id:Date.now(),name:n||u,url:u,type}]);
    setN(""); setU("");
  };

  return (
    <div>
      {files.map(f=>(
        <div key={f.id} style={{display:"flex",alignItems:"center",gap:10,marginBottom:8,padding:"10px 12px",background:C.surface2,borderRadius:8}}>
          <div style={{fontSize:11,padding:"2px 6px",borderRadius:20,background:`${fileIcons[f.type]?.color}22`,color:fileIcons[f.type]?.color,border:`0.5px solid ${fileIcons[f.type]?.color}44`,flexShrink:0}}>{fileIcons[f.type]?.label||"Fil"}</div>
          <div style={{flex:1,fontSize:13,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{f.name}</div>
          <a href={f.url} target="_blank" rel="noreferrer" style={{fontSize:12,color:C.orange,textDecoration:"none",flexShrink:0}}>↗</a>
          <button onClick={()=>onChange(files.filter(x=>x.id!==f.id))} style={{background:"none",border:"none",color:"#555",cursor:"pointer",fontSize:18,flexShrink:0}}>×</button>
        </div>
      ))}
      <div style={{display:"flex",flexDirection:"column",gap:8,marginTop:12}}>
        <input style={inp()} placeholder="Navn (valgfritt)" value={n} onChange={e=>setN(e.target.value)}/>
        <div style={{display:"flex",gap:8}}>
          <input style={inp({flex:1})} placeholder="Google Drive / Docs lenke..." value={u} onChange={e=>setU(e.target.value)} onKeyDown={e=>e.key==="Enter"&&add()}/>
          <button style={btn("primary",{flexShrink:0})} onClick={add}>+ Legg til</button>
        </div>
      </div>
    </div>
  );
}